/**
 * Maps each weapon name to its type (Primary, Secondary, Melee).
 * Used to filter weapon dropdown by selected type.
 * Based on Torn City weapon classifications.
 */
export const WEAPON_TYPE_MAP = {
  '9mm Uzi': 'Secondary',
  'AK-47': 'Primary',
  'AK74U': 'Primary',
  'ArmaLite M-15A4': 'Primary',
  'Axe': 'Melee',
  'Ban Hammer': 'Melee',
  'Baseball Bat': 'Melee',
  'Benelli M1 Tactical': 'Primary',
  'Benelli M4 Super': 'Primary',
  'Beretta 92FS': 'Secondary',
  'Beretta M9': 'Secondary',
  'Beretta Pico': 'Secondary',
  'Blood Spattered Sickle': 'Melee',
  'Blowgun': 'Melee',
  'Blunderbuss': 'Primary',
  'Bolt Gun': 'Primary',
  'Bone Saw': 'Melee',
  'Bo Staff': 'Melee',
  'Bread Knife': 'Melee',
  'BT MP9': 'Secondary',
  'Bug Swatter': 'Melee',
  'Bushmaster Carbon 15': 'Primary',
  'Butterfly Knife': 'Melee',
  'Cattle Prod': 'Melee',
  'Chainsaw': 'Melee',
  'Chain Whip': 'Melee',
  'China Lake': 'Primary',
  'Claymore Sword': 'Melee',
  'Cleaver': 'Melee',
  'Cobra Derringer': 'Secondary',
  'Combat Shotgun': 'Primary',
  'Cricket Bat': 'Melee',
  'Crossbow': 'Melee',
  'Crowbar': 'Melee',
  'Crystalline Falcata': 'Melee',
  'Dagger': 'Melee',
  'Desert Eagle': 'Secondary',
  "Devil's Pitchfork": 'Melee',
  'Diamond Bladed Knife': 'Melee',
  'Diamond Icicle': 'Melee',
  'Dual 92G Berettas': 'Secondary',
  'Dual Axes': 'Melee',
  'Dual Bushmasters': 'Primary',
  'Dual Hammers': 'Melee',
  'Dual MP5s': 'Secondary',
  'Dual P90s': 'Secondary',
  'Dual Samurai Swords': 'Melee',
  'Dual Scimitars': 'Melee',
  'Dual TMPs': 'Secondary',
  'Dual Uzis': 'Secondary',
  "Duke's Hammer": 'Melee',
  'Egg Propelled Launcher': 'Primary',
  'Enfield SA-80': 'Primary',
  'Fine Chisel': 'Melee',
  'Fiveseven': 'Secondary',
  'Flail': 'Melee',
  'Flamethrower': 'Primary',
  'Flare Gun': 'Secondary',
  'Frying Pan': 'Melee',
  'Glock 17': 'Secondary',
  'Golden Broomstick': 'Melee',
  'Gold Plated AK-47': 'Primary',
  'Golf Club': 'Melee',
  'Guandao': 'Melee',
  'Hammer': 'Melee',
  'Handbag': 'Melee',
  'Harpoon': 'Primary',
  'Heckler & Koch SL8': 'Primary',
  'Homemade Pocket Shotgun': 'Primary',
  'Ice Pick': 'Melee',
  'Ithaca 37': 'Primary',
  'Ivory Walking Cane': 'Melee',
  'Jackhammer': 'Primary',
  'Kama': 'Melee',
  'Katana': 'Melee',
  'Kitchen Knife': 'Melee',
  'Knuckle Dusters': 'Melee',
  'Kodachi': 'Melee',
  'Lead Pipe': 'Melee',
  'Leather Bullwhip': 'Melee',
  'Lorcin 380': 'Secondary',
  'Luger': 'Secondary',
  'M16 A2 Rifle': 'Primary',
  'M249 SAW': 'Primary',
  'M4A1 Colt Carbine': 'Primary',
  'MAC 10': 'Secondary',
  'Macana': 'Melee',
  'Madball': 'Melee',
  'Mag 7': 'Primary',
  'Magnum': 'Secondary',
  'Meat Hook': 'Melee',
  'Metal Nunchaku': 'Melee',
  'Milkor MGL': 'Primary',
  'Millwall Brick': 'Melee',
  'Minigun': 'Primary',
  'MP 40': 'Primary',
  'MP5 Navy': 'Secondary',
  'MP5k': 'Secondary',
  'MP9': 'Secondary',
  'Naval Cutlass': 'Melee',
  'Negev NG-5': 'Primary',
  'Neutrilux 2000': 'Primary',
  'Ninja Claws': 'Melee',
  'Nock Gun': 'Primary',
  'P90': 'Secondary',
  'Pair of High Heels': 'Melee',
  'Pair of Ice Skates': 'Melee',
  'Penelope': 'Secondary',
  'Pen Knife': 'Melee',
  'Petrified Humerus': 'Melee',
  'Pillow': 'Melee',
  'Pink Mac-10': 'Secondary',
  'PKM': 'Primary',
  'Plastic Sword': 'Melee',
  'Poison Umbrella': 'Melee',
  'Prototype Qsz-92': 'Secondary',
  'Raven MP25': 'Secondary',
  'Rheinmetall MG 3': 'Primary',
  'Riding Crop': 'Melee',
  'RPG Launcher': 'Primary',
  'Ruger 57': 'Secondary',
  'Rusty Sword': 'Melee',
  'Sai': 'Melee',
  'Samurai Sword': 'Melee',
  'Sawed-Off Shotgun': 'Primary',
  'Scalpel': 'Melee',
  'Scimitar': 'Melee',
  'SIG 550': 'Primary',
  'SIG 552': 'Primary',
  'Skorpion': 'Secondary',
  'SKS Carbine': 'Primary',
  'Sledgehammer': 'Melee',
  'Slingshot': 'Melee',
  'SMAW Launcher': 'Primary',
  'Snow Cannon': 'Primary',
  'Spear': 'Melee',
  'Springfield 1911': 'Secondary',
  'Steyr AUG': 'Primary',
  'Stoner 96': 'Primary',
  'Swiss Army Knife': 'Melee',
  'S&W M29': 'Secondary',
  'S&W Revolver': 'Secondary',
  'Taser': 'Secondary',
  'Taurus': 'Secondary',
  'Tavor': 'Primary',
  'TAR-21': 'Primary',
  'Thompson': 'Primary',
  'TMP': 'Secondary',
  'Tranquilizer Gun': 'Secondary',
  'Twin Tiger Hooks': 'Melee',
  'Type 98 Anti Tank': 'Primary',
  'USP': 'Secondary',
  'Vektor CR-21': 'Primary',
  'Wand of Destruction': 'Melee',
  'Wooden Nunchaku': 'Melee',
  'Wushu Double Axes': 'Melee',
  'XM8 Rifle': 'Primary',
  'Yasukuni Sword': 'Melee',
};
